import SpjIndex from '@/views/spj/SpjIndex.vue';

const spj = [
    {
        path: '/spj',
        name: 'spj',
        component: SpjIndex
    }
]

export default spj